var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"rounded-lg rounded-be-4xl max-w-full bg-light-ui-200 dark:bg-dark-ui-200",style:({ width: `${_vm.cardWidth}px`, height: `${_vm.cardWidth / 2}px` })})
}
var staticRenderFns = []

export { render, staticRenderFns }